import http from "../http-common";


const getUSStates = () => {
  return http.get("/get-us-states");
};
const getCanadaStates = () => {
    return http.get("/get-canada-states");
  };
const StateService = {
    getUSStates,
    getCanadaStates,
}
export default StateService;